import {IdentificacionCFEDTO} from './IdentificacionCFEDTO';
import {EmisorCFEDTO} from './EmisorCFEDTO';
import {ReceptorCFEDTO} from './ReceptorCFEDTO';
import {TotalesCFEDTO} from './TotalesCFEDTO';
import {DetalleCFEDTO} from './DetalleCFEDTO';
import {AdendaDTO} from './AdendaDTO';
import {ReferenciasCFEDTO} from './ReferenciasCFEDTO';

export class CFEDTO
{
  eMail: string;

  identificacionCFE: IdentificacionCFEDTO;
  emisorCFE: EmisorCFEDTO;
  receptorCFE: ReceptorCFEDTO;
  totalesCFE: TotalesCFEDTO;
  detallesCFEs: Array<DetalleCFEDTO>;
  anulacionesCFEs: Array<CFEDTO>;
  adenda: AdendaDTO;
  referenciasCFE: ReferenciasCFEDTO;
  auditDate: Date;

  toString(): string
  {
    return null;
  }
}
